<template>
  <div class="row empty-state">
    <img
      v-if="imageSrc"
      :src="imageSrc"
      :alt="imageAlt || title"
      class="empty-state__image"
    />
    <h3 class="title">
      {{ title }}
    </h3>
    <p class="message">
      {{ message }}
    </p>
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    buttonText: { type: String, default: '' },
    imageSrc: { type: String, default: '' },
    imageAlt: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.empty-state__image {
  display: block;
  height: auto;
  margin: 0 auto var(--space-normal);
  max-width: min(48rem, 90vw);
  width: 100%;
}
</style>
